export default "/icons/docker_icon.svg";